import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/components/Login/Welcome' // 欢迎页
import Login from '@/components/Login/Login' // 微信授权登录
import Account from '@/components/Login/Account' // 账号密码登陆

import Mine from '@/components/Index/Mine' // 我的
import Notice from '@/components/Index/Notice' // 我的 通知管理
import Index from '@/components/Index/Index' // 首页
import Village from '@/components/Index/Village' // 选择小区

import Repair from '@/components/Repair/Repair' // 报修管理 报修
import Evaluate from '@/components/Repair/Evaluate' // 报修管理 去评价
import RepairCenter from '@/components/Repair/RepairCenter' // 报修管理 报修中心
import RepairDetail from '@/components/Repair/RepairDetail' // 报修管理 报修详情
import Repairman from '@/components/Repair/Repairman' // 报修管理 维修师傅
import SelectRepairman from '@/components/Repair/SelectRepairman' // 报修管理 选择维修师傅
import CheckRepairman from '@/components/Repair/CheckRepairman' // 报修管理 选择主维修师傅和从维修师傅
import SelectBuilding from '@/components/Repair/SelectBuilding' // 报修管理 选择楼栋
import Reason from '@/components/Repair/Reason' // 保修管理 无法完成原因

import Material from '@/components/Material/Material' // 物资管理 首页
import MaterialAdd from '@/components/Material/MaterialAdd' // 物资管理 新增物资

import GoodsList from '@/components/Material/Goods/GoodsList' // 物资管理 物品档案
import GoodsDetail from '@/components/Material/Goods/GoodsDetail' // 物资管理 物品档案 详情

import AssetList from '@/components/Material/Asset/AssetList' // 物资管理 资产查看
import AssetDetail from '@/components/Material/Asset/AssetDetail' // 物资管理 资产查看详情

import WarehouseOut from '@/components/Material/WarehouseOut/WarehouseOut' // 物资管理 维修用料出库单
import WarehouseOutDetail from '@/components/Material/WarehouseOut/WarehouseOutDetail' // 物资管理 维修用料出库单 详情
import WarehouseOutAccount from '@/components/Material/WarehouseOut/WarehouseOutAccount' // 物资管理 维修用料出库单 记账
import WarehouseOutAdd from '@/components/Material/WarehouseOut/WarehouseOutAdd' // 物资管理 维修用料出库单 新增

import StocktakingList from '@/components/Material/Stocktaking/StocktakingList' // 物资管理 耗材盘点列表
import StocktakingAdd from '@/components/Material/Stocktaking/StocktakingAdd' // 物资管理 耗材盘点单添加
import StocktakingInfo from '@/components/Material/Stocktaking/StocktakingInfo' // 物资管理 耗材盘点单详情
import StocktakingDetail from '@/components/Material/Stocktaking/StocktakingDetail' // 物资管理 耗材盘点页面
import StocktakingEnterCode from '@/components/Material/Stocktaking/StocktakingEnterCode' // 物资管理 耗材盘点 录码

import AssetStocktakingList from '@/components/Material/AssetStocktaking/AssetStocktakingList' // 物资管理 资产盘点列表
import AssetStocktakingAdd from '@/components/Material/AssetStocktaking/AssetStocktakingAdd' // 物资管理 资产盘点单添加
import AssetStocktakingInfo from '@/components/Material/AssetStocktaking/AssetStocktakingInfo' // 物资管理 资产盘点单详情
import AssetStocktakingDetail from '@/components/Material/AssetStocktaking/AssetStocktakingDetail' // 物资管理 资产盘点页面
import AssetStocktakingEnterCode from '@/components/Material/AssetStocktaking/AssetStocktakingEnterCode' // 物资管理 资产盘点 录码
import AssetStocktakingProfit from '@/components/Material/AssetStocktaking/AssetStocktakingProfit' // 物资管理 资产盘点 盘盈

import InvoiceList from '@/components/Material/Invoice/InvoiceList' // 物资管理 维修耗材出库单
import InvoiceDetail from '@/components/Material/Invoice/InvoiceDetail' // 物资管理 维修耗材出库单 详情
import SelecteGoods from '@/components/Material/Invoice/SelecteGoods' // 物资管理 维修耗材出库单 选择物品
import InvoiceAdd from '@/components/Material/Invoice/InvoiceAdd' // 物资管理 维修耗材出库单 新增

import RequisitionList from '@/components/Material/purchase/RequisitionList' // 物资管理 采购入库单
import RequisitionDetail from '@/components/Material/purchase/RequisitionDetail' // 物资管理 采购入库单 详情
import RequisitionSelecteGoods from '@/components/Material/purchase/RequisitionSelecteGoods' // 物资管理 维修耗材出库单 选择物品
import RequisitionAdd from '@/components/Material/purchase/RequisitionAdd' // 物资管理 采购入库单 新增

import MyApproval from '@/components/Approval/MyApproval' // 审批 审批工作台
import ApprovalInfo from '@/components/Approval/ApprovalInfo' // 审批 审批详情

import CodeMessage from '@/components/TravelControl/CodeMessage' // 出行管控 扫码

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Account',
      name: 'Account',
      component: Account
    },
    {
      path: '/Welcome',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/Mine',
      name: 'Mine',
      component: Mine
    },
    {
      path: '/Notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index
    },
    {
      path: '/Repair',
      name: 'Repair',
      component: Repair
    },
    {
      path: '/Evaluate',
      name: 'Evaluate',
      component: Evaluate
    },
    {
      path: '/Reason',
      name: 'Reason',
      component: Reason
    },
    {
      path: '/RepairDetail',
      name: 'RepairDetail',
      component: RepairDetail
    },
    {
      path: '/RepairCenter',
      name: 'RepairCenter',
      component: RepairCenter
    },
    {
      path: '/Repairman',
      name: 'Repairman',
      component: Repairman
    },
    {
      path: '/SelectRepairman',
      name: 'SelectRepairman',
      component: SelectRepairman
    },
    {
      path: '/CheckRepairman',
      name: 'CheckRepairman',
      component: CheckRepairman
    },
    {
      path: '/SelectBuilding',
      name: 'SelectBuilding',
      component: SelectBuilding
    },
    {
      path: '/Village',
      name: 'Village',
      component: Village
    },
    {
      path: '/Material',
      name: 'Material',
      component: Material
    },
    {
      path: '/WarehouseOut',
      name: 'WarehouseOut',
      component: WarehouseOut
    },
    {
      path: '/WarehouseOutDetail',
      name: 'WarehouseOutDetail',
      component: WarehouseOutDetail
    },
    {
      path: '/WarehouseOutAccount',
      name: 'WarehouseOutAccount',
      component: WarehouseOutAccount
    },
    {
      path: '/WarehouseOutAdd',
      name: 'WarehouseOutAdd',
      component: WarehouseOutAdd
    },
    {
      path: '/MaterialAdd',
      name: 'MaterialAdd',
      component: MaterialAdd
    },
    {
      path: '/GoodsList',
      name: 'GoodsList',
      component: GoodsList
    },
    {
      path: '/GoodsDetail',
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/AssetList',
      name: 'AssetList',
      component: AssetList
    },
    {
      path: '/AssetDetail',
      name: 'AssetDetail',
      component: AssetDetail
    },
    {
      path: '/StocktakingList',
      name: 'StocktakingList',
      component: StocktakingList
    },
    {
      path: '/StocktakingInfo',
      name: 'StocktakingInfo',
      component: StocktakingInfo
    },
    {
      path: '/StocktakingAdd',
      name: 'StocktakingAdd',
      component: StocktakingAdd
    },
    {
      path: '/StocktakingDetail',
      name: 'StocktakingDetail',
      component: StocktakingDetail
    },
    {
      path: '/StocktakingEnterCode',
      name: 'StocktakingEnterCode',
      component: StocktakingEnterCode
    },
    {
      path: '/AssetStocktakingList',
      name: 'AssetStocktakingList',
      component: AssetStocktakingList
    },
    {
      path: '/AssetStocktakingInfo',
      name: 'AssetStocktakingInfo',
      component: AssetStocktakingInfo
    },
    {
      path: '/AssetStocktakingAdd',
      name: 'AssetStocktakingAdd',
      component: AssetStocktakingAdd
    },
    {
      path: '/AssetStocktakingDetail',
      name: 'AssetStocktakingDetail',
      component: AssetStocktakingDetail
    },
    {
      path: '/AssetStocktakingEnterCode',
      name: 'AssetStocktakingEnterCode',
      component: AssetStocktakingEnterCode
    },
    {
      path: '/AssetStocktakingProfit',
      name: 'AssetStocktakingProfit',
      component: AssetStocktakingProfit
    },
    {
      path: '/InvoiceList',
      name: 'InvoiceList',
      component: InvoiceList
    },
    {
      path: '/InvoiceDetail',
      name: 'InvoiceDetail',
      component: InvoiceDetail
    },
    {
      path: '/SelecteGoods',
      name: 'SelecteGoods',
      component: SelecteGoods
    },
    {
      path: '/InvoiceAdd',
      name: 'InvoiceAdd',
      component: InvoiceAdd
    },
    {
      path: '/RequisitionList',
      name: 'RequisitionList',
      component: RequisitionList
    },
    {
      path: '/RequisitionDetail',
      name: 'RequisitionDetail',
      component: RequisitionDetail
    },
    {
      path: '/RequisitionAdd',
      name: 'RequisitionAdd',
      component: RequisitionAdd
    },
    {
      path: '/RequisitionSelecteGoods',
      name: 'RequisitionSelecteGoods',
      component: RequisitionSelecteGoods
    },
    {
      path: '/MyApproval',
      name: 'MyApproval',
      component: MyApproval
    },
    {
      path: '/ApprovalInfo',
      name: 'ApprovalInfo',
      component: ApprovalInfo
    },
    {
      path: '/CodeMessage',
      name: 'CodeMessage',
      component: CodeMessage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js